<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  @if (isRmbRmc) {
  <p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
  }
  <div class="d-flex">
    @if (isHead) {
    <div class="pe-2">
      <h1 class="person-label">{{ "HEAD_OF_HOUSEHOLD" | globalTranslate }}</h1>
    </div>
    } @if (!isPresumptive) {
    <div>
      <h1 class="person-label">{{ selectedIndividual | fullname }}</h1>
    </div>
    }
  </div>

  <div [formGroup]="getControl('data')">
    @if (isFosterCare) {
    <div>
      <h2 class="section-header">{{ "FORMER_FROSTER" | globalTranslate }}</h2>
      <hr />
      <section>
        @if (isEnabled('data.formerFosterCare')) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'WAS' | globalTranslate }}{{
            selectedIndividual | fullname
          }} {{ 'FORMER_FROSTER_STATIC_TEXT' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="formerFosterCare"
            [attr.aria-label]="
              ('WAS' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('FORMER_FROSTER_STATIC_TEXT' | globalTranslate)
            "
            formControlName="formerFosterCare"
            [attr.aria-required]="true"
            [items]="tableCodeValue('YESNO', 'data.formerFosterCare')"
            (change)="isGreaterafterTwentyThree()"
            required
          ></select>
        </nh-field>
        }
      </section>
    </div>
    }

    <!-- Show all the sections PREGNANCY, PAST-PREGNANCY and EMS only when age is >18  before 01/01/2023 ,
      irrespective of answer to FORMER FOSTERCARE question-->
    <!-- OR -->
    <!-- when age is >18  after 01/01/2023 and FORMER FOSTERCARE question is 'NO',
      then Show all the sections PREGNANCY, PAST-PREGNANCY and EMS -->

    <!-- when age is >18  after 01/01/2023 and FORMER FOSTERCARE question is 'YES',
      go to to FINISH screen-->

    @if (( ((ageGreaterThanEighteenOnTwentyThree === false) &&
    isN('data.formerFosterCare')) || ageGreaterThanEighteenOnTwentyThree ||
    !isEnabled('data.formerFosterCare'))) {
    <div>
      @if (isPresumptive) {
      <div>
        <h2 class="section-header">Tax Information</h2>
        <hr />
        <section [formGroup]="getControl('data.taxFilerInfo')">
          @if (isEnabled('data.taxFilerInfo.filing')) {
          <nh-field
            id="ad_filing"
            [mandatory]="false"
            [attr.aria-required]="false"
            label="Is {{
              selectedIndividual | fullname
            }} planning to file a federal income tax return the next time taxes are due?"
            class="label-section"
          >
            <select
              nhTranslate
              name="filing"
              formControlName="filing"
              [attr.aria-label]="
                'Is' +
                ' ' +
                (selectedIndividual | fullname) +
                ' ' +
                'planning to file a federal income tax return the next time taxes are due?'
              "
              [items]="tableCodeValue('YESNO', 'data.taxFilerInfo.filing')"
            ></select>
          </nh-field>
          } @if (isN('data.taxFilerInfo.filing')) {
          <nh-field
            id="ad_hasTaxDependentOutside"
            [mandatory]="false"
            [attr.aria-required]="false"
            label="Is {{
              selectedIndividual | fullname
            }} being claimed as a dependent by someone outside of the home?"
            class="label-section"
          >
            <select
              nhTranslate
              name="hasTaxDependentOutside"
              [attr.aria-label]="
                'Is' +
                ' ' +
                (selectedIndividual | fullname) +
                ' ' +
                'being claimed as a dependent by someone outside of the home?'
              "
              [items]="
                tableCodeValue(
                  'YESNO',
                  'data.taxFilerInfo.hasTaxDependentOutside'
                )
              "
              formControlName="hasTaxDependentOutside"
            ></select>
          </nh-field>
          }
        </section>
      </div>
      }
    </div>
    }

    <!-- {{isPregnable}} {{ (ageGreaterThanEighteenOnTwentyThree === false)}} {{ isN('data.formerFosterCare') }} {{ ageGreaterThanEighteenOnTwentyThree }} -->
    @if (isPregnable && ( ((ageGreaterThanEighteenOnTwentyThree === false) &&
    isN('data.formerFosterCare') && appTypePregnancy !== 'PRG') ||
    ((ageGreaterThanEighteenOnTwentyThree === false) && appTypePregnancy ===
    'PRG') || ageGreaterThanEighteenOnTwentyThree ||
    !isEnabled('data.formerFosterCare'))) {
    <div>
      <h2 class="section-header">
        {{ "PREGNANCY" | globalTranslate }}
      </h2>
      <hr />
      <section [formGroup]="getControl('data.pregnancyOne')">
        <div>
          @if (isEnabled('data.pregnancyOne.isPregnant')) {
          <nh-field
            id="ad_isPregnant"
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'IS_1' | globalTranslate }}{{
              selectedIndividual | fullname
            }} {{ 'PREGNANCY_STATIC_TEXT1' | globalTranslate }}"
            class="label-section"
          >
            <select
              nhTranslate
              name="isPregnant"
              [attr.aria-label]="
                ('IS_1' | globalTranslate) +
                ' ' +
                (selectedIndividual | fullname) +
                ' ' +
                ('PREGNANCY_STATIC_TEXT1' | globalTranslate)
              "
              [attr.aria-required]="true"
              [items]="tableCodeValue('YESNO', 'data.pregnancyOne.isPregnant')"
              (change)="isPregnantChanged($event)"
              formControlName="isPregnant"
            ></select>
          </nh-field>
          }
        </div>
        <!-- <nh-field *ngIf="isEnabled('data.pregnancyOne.hadBabySw')"
                label="{{'HAS_1' | globalTranslate}} {{ selectedIndividual | fullname }} {{'HAD_BABY' | globalTranslate}}"
                class="label-section">
                | globalTranslate nh name="hadBabySw" aria-label="hadBabySw"
              [items]="tableCodeValue('YESNO', 'data.pregnancyOne.hadBabySw')" formControlName="hadBabySw"></select>
            </nh-field> -->
        <div>
          @if (isEnabled('data.pregnancyOne.stillPregSw')) {
          <nh-field
            id="ad_stillPregSw"
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'IS_1' | globalTranslate }}{{
              selectedIndividual | fullname
            }} {{ 'STILL_PREGNANT' | globalTranslate }}"
            class="label-section"
          >
            <select
              nhTranslate
              name="stillPregSw"
              [attr.aria-label]="
                ('IS_1' | globalTranslate) +
                ' ' +
                (selectedIndividual | fullname) +
                ' ' +
                ('STILL_PREGNANT' | globalTranslate)
              "
              [attr.aria-required]="true"
              [items]="tableCodeValue('YESNO', 'data.pregnancyOne.stillPregSw')"
              formControlName="stillPregSw"
            ></select>
          </nh-field>
          } @if (isEnabled('data.pregnancyOne.numberOfBabies')) {
          <nh-field
            id="ad_numberOfBabies"
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'HOW_MANY_BABIES' | globalTranslate }} {{
              selectedIndividual | fullname
            }} {{ 'EXPECTING' | globalTranslate }}"
            class="label-section"
          >
            <select
              nh
              name="numberOfBabies"
              [attr.aria-label]="
                ('HOW_MANY_BABIES' | globalTranslate) +
                ' ' +
                (selectedIndividual | fullname) +
                ' ' +
                ('EXPECTING' | globalTranslate)
              "
              [attr.aria-required]="true"
              [items]="
                tableCodeValue(
                  'NUMBEROFBIRTHS',
                  'data.pregnancyOne.numberOfBabies'
                )
              "
              formControlName="numberOfBabies"
            ></select>
          </nh-field>
          } @if (isEnabled('data.pregnancyOne.pregEndDate')) {
          <nh-field
            id="ad_pregEndDate"
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'WHAT_WAS' | globalTranslate }} {{
              selectedIndividual | fullname
            }}{{ 'PREGNANCY_END_DATE' | globalTranslate }}"
            class="label-section"
          >
            @if (isEnabled('data.pregnancyOne.pregEndDate')) {
            <div class="hint">
              {{ "PERSON_DUE_DATE_STATIC_TEXT" | globalTranslate }}
            </div>
            }
            <nh-datepicker>
              <input
                type="text"
                name="pregEndDate"
                class="form-control"
                (change)="isInvalidDate($event)"
                [attr.aria-label]="
                  ('WHAT_WAS' | globalTranslate) +
                  ' ' +
                  (selectedIndividual | fullname) +
                  ' ' +
                  ('PREGNANCY_END_DATE' | globalTranslate)
                "
                [attr.aria-required]="true"
                formControlName="pregEndDate"
                bsDatepicker
                nh
                [maxDate]="today"
                [minDate]="minimumPregDate"
                maxlength="10"
              />
            </nh-datepicker>
          </nh-field>
          } @if (isEnabled('data.pregnancyOne.dueDate')) {
          <nh-field
            id="ad_dueDate"
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'WHAT_IS' | globalTranslate }} {{
              selectedIndividual | fullname
            }}{{ 'PERSON_DUE_DATE' | globalTranslate }}"
            class="label-section"
          >
            @if (isEnabled('data.pregnancyOne.dueDate')) {
            <div class="hint">
              {{ "PERSON_DUE_DATE_STATIC_TEXT" | globalTranslate }}
            </div>
            }
            <nh-datepicker>
              <input
                type="text"
                name="dueDate"
                class="form-control"
                (change)="isInvalidDate($event)"
                [minDate]="today"
                [attr.aria-label]="
                  ('WHAT_IS' | globalTranslate) +
                  ' ' +
                  (selectedIndividual | fullname) +
                  ' ' +
                  ('PERSON_DUE_DATE' | globalTranslate)
                "
                [attr.aria-required]="true"
                [maxDate]="maximumDueDate"
                formControlName="dueDate"
                bsDatepicker
                nh
                maxlength="10"
              />
            </nh-datepicker>
          </nh-field>
          }
          <!-- <nh-field *ngIf="isEnabled('data.pregnancyOne.haveBabyDate')" label="{{'WHEN_DID' | globalTranslate}} {{ selectedIndividual | fullname }} {{'HAVE_BABY' | globalTranslate}}"
                  class="label-section">
                  <div class="hint" *ngIf="isEnabled('data.pregnancyOne.haveBabyDate')">{{'PERSON_DUE_DATE_STATIC_TEXT' |
                  translate}}</div>
                  <nh-datepicker>
                    <input type="text" name="haveBabyDate" class="form-control" (change)="isInvalidDate($event)"
                      formControlName="haveBabyDate" bsDatepicker nh [maxDate]="today" [minDate]="minimumPregDate"
                      maxlength="10">
                    </nh-datepicker>
                  </nh-field> -->
          @if (isEnabled('data.pregnancyOne.addBabiesSw') && (isRmbRmc)) {
          <nh-field
            id="ad_addBabiesSw"
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'PEOPLE_DELETE_STATIC_TEXT11' | globalTranslate }}"
          >
            <select
              nhTranslate
              name="addBabiesSw"
              formControlName="addBabiesSw"
              [attr.aria-label]="
                'PEOPLE_DELETE_STATIC_TEXT11' | globalTranslate
              "
              [attr.aria-required]="true"
              [required]="true"
              [items]="tableCodeValue('YESNO', 'data.pregnancyOne.addBabiesSw')"
            ></select>
          </nh-field>
          } @if (isEnabled('data.pregnancyOne.noOfBabiesBorn')) {
          <nh-field
            id="ad_noOfBabiesBorn"
            [isRow]="true"
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'PEOPLE_DELETE_STATIC_TEXT12' | globalTranslate }} "
          >
            <select
              nh
              name="noOfBabiesBorn"
              (change)="
                addDynamicRows(
                  this.getValue('data.pregnancyOne.noOfBabiesBorn')
                )
              "
              [items]="
                tableCodeValue(
                  'NUMBEROFBIRTHS',
                  'data.pregnancyOne.noOfBabiesBorn'
                )
              "
              [required]="true"
              formControlName="noOfBabiesBorn"
              [attr.aria-label]="
                'PEOPLE_DELETE_STATIC_TEXT12' | globalTranslate
              "
              [attr.aria-required]="true"
            ></select>
          </nh-field>
          } @if (showNewbornList) {
          <div formArrayName="newBornInfoList">
            <div>
              @for (row of newBornInfoList.controls; track row; let i = $index)
              {
              <div [formGroupName]="i" class="col-md-8 col-sm-12 my-4 pl-0">
                <h2 class="section-header pb-2">
                  {{ "PEOPLE_DELETE_STATIC_TEXT13" | globalTranslate }}
                </h2>
                <hr />
                <div class="row g-3 col-lg-12 pl-0">
                  <div class="col-md-4 col-sm-12">
                    <nh-field
                      id="ad_newbornFirstName"
                      [isRow]="true"
                      [mandatory]="true"
                      [attr.aria-required]="true"
                      label="{{ 'FIRST_NAME' | globalTranslate }}"
                    >
                      <input
                        type="text"
                        name="newbornFirstName"
                        formControlName="newbornFirstName"
                        [attr.aria-label]="'FIRST_NAME' | globalTranslate"
                        [attr.aria-required]="true"
                        class="form-control"
                        maxlength="45"
                        [required]="true"
                      />
                    </nh-field>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <nh-field
                      id="ad_newbornMiddleName"
                      [isRow]="true"
                      [mandatory]="false"
                      [attr.aria-required]="false"
                      label="{{ 'MIDDLE_NAME' | globalTranslate }}"
                    >
                      <input
                        type="text"
                        name="newbornMiddleName"
                        formControlName="newbornMiddleName"
                        [attr.aria-label]="'MIDDLE_NAME' | globalTranslate"
                        class="form-control"
                        mask="S"
                      />
                    </nh-field>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <nh-field
                      id="ad_newbornLastName"
                      [isRow]="true"
                      [mandatory]="true"
                      [attr.aria-required]="true"
                      label="{{ 'LAST_NAME' | globalTranslate }}"
                    >
                      <input
                        type="text"
                        name="newbornLastName"
                        formControlName="newbornLastName"
                        [attr.aria-label]="'LAST_NAME' | globalTranslate"
                        [attr.aria-required]="true"
                        class="form-control"
                        maxlength="45"
                        [required]="true"
                      />
                    </nh-field>
                  </div>
                </div>
                <nh-field
                  id="ad_newbornDOB"
                  label="{{ 'DOB' | globalTranslate }}"
                  [isRow]="true"
                  [mandatory]="true"
                  [attr.aria-required]="true"
                >
                  <nh-datepicker>
                    <input
                      type="text"
                      name="newbornDOB"
                      placeholder="mm/dd/yyyy"
                      class="form-control"
                      formControlName="newbornDOB"
                      bsDatepicker
                      nh
                      [required]="true"
                      [minDate]="minimumDate"
                      [maxDate]="today"
                      [attr.aria-label]="'DOB' | globalTranslate"
                      [attr.aria-required]="true"
                    />
                  </nh-datepicker>
                </nh-field>
                <nh-field
                  id="ad_gender"
                  [isRow]="true"
                  [mandatory]="true"
                  [attr.aria-required]="true"
                  label="{{ 'GENDER' | globalTranslate }}"
                >
                  <select
                    nhTranslate
                    name="gender"
                    formControlName="gender"
                    [attr.aria-label]="'GENDER' | globalTranslate"
                    [attr.aria-required]="true"
                    [required]="true"
                    [items]="tableCodeValue('GENDER', i)"
                  ></select>
                </nh-field>
                <nh-field
                  id="ad_ssn"
                  [isRow]="true"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                  label="{{ 'SSN' | globalTranslate }}"
                >
                  <input
                    type="text"
                    name="ssn"
                    formControlName="ssn"
                    class="form-control"
                    placeholder="XXX-XX-XXXX"
                    mask="000-00-0000"
                    [attr.aria-label]="'SSN' | globalTranslate"
                  />
                </nh-field>
              </div>
              }
            </div>
          </div>
          }
        </div>
      </section>
      @if (!closePregDueDateNudge) {
      <div>
        @if (showPastPregDueDateNudge) {
        <nh-nudge
          [message]="'NUDGETEXT_03' | globalTranslate"
          (close)="closeSnackbar()"
        ></nh-nudge>
        }
      </div>
      }
    </div>
    } @if (isPregnable && !disablePastPreg && isPregnableAndMovedIn && (
    ((ageGreaterThanEighteenOnTwentyThree === false) &&
    isN('data.formerFosterCare') && appTypePregnancy !== 'PRG') ||
    ((ageGreaterThanEighteenOnTwentyThree === false) && appTypePregnancy ===
    'PRG') || ageGreaterThanEighteenOnTwentyThree ||
    !isEnabled('data.formerFosterCare'))) {
    <div>
      <h2 class="section-header">
        <strong>{{ "PAST_PREGNANCY" | globalTranslate }}</strong>
      </h2>
      <hr />
      <section [formGroup]="getControl('data.pregnancyOne')">
        @if (isEnabled('data.pregnancyOne.nextPregSw')) {
        <nh-field
          id="ad_nextPregSw"
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'DOES_PASTPREGNANCY' | globalTranslate }}{{
            selectedIndividual | fullname
          }} {{ 'PAST_PREGNANCY_STATIC_TEXT' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="nextPregSw"
            [attr.aria-label]="
              ('DOES_PASTPREGNANCY' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('PAST_PREGNANCY_STATIC_TEXT' | globalTranslate)
            "
            [attr.aria-required]="true"
            [items]="tableCodeValue('YESNO', 'data.pregnancyOne.nextPregSw')"
            formControlName="nextPregSw"
          ></select>
        </nh-field>
        } @if (isEnabled('data.pregnancyOne.nextPregNumberOfBabies')) {
        <nh-field
          id="ad_nextPregNumberOfBabies"
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'HOW_MANY_BABIES_WAS' | globalTranslate }} {{
            selectedIndividual | fullname
          }} {{ 'EXPECTING' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="nextPregNumberOfBabies"
            [attr.aria-label]="
              ('HOW_MANY_BABIES_WAS' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('EXPECTING' | globalTranslate)
            "
            [attr.aria-required]="true"
            [items]="
              tableCodeValue(
                'NUMBEROFBIRTHS',
                'data.pregnancyOne.nextPregNumberOfBabies'
              )
            "
            formControlName="nextPregNumberOfBabies"
          ></select>
        </nh-field>
        } @if (isEnabled('data.pregnancyOne.nextPregDueDate')) {
        <nh-field
          id="ad_nextPregDueDate"
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'WHAT_WAS' | globalTranslate }} {{
            selectedIndividual | fullname
          }}{{ 'PREGNANCY_END_DATE' | globalTranslate }}"
          class="label-section"
        >
          @if (isEnabled('data.pregnancyOne.nextPregDueDate')) {
          <div class="hint">
            {{ "PERSON_DUE_DATE_STATIC_TEXT" | globalTranslate }}
          </div>
          }
          <nh-datepicker>
            <input
              type="text"
              name="nextPregDueDate"
              class="form-control"
              (change)="isInvalidDate($event)"
              formControlName="nextPregDueDate"
              [maxDate]="today"
              [minDate]="minimumPregDate"
              bsDatepicker
              nh
              maxlength="10"
              [attr.aria-label]="
                ('WHAT_WAS' | globalTranslate) +
                ' ' +
                (selectedIndividual | fullname) +
                ' ' +
                ('PREGNANCY_END_DATE' | globalTranslate)
              "
              [attr.aria-required]="true"
            />
          </nh-datepicker>
        </nh-field>
        }
      </section>
    </div>
    }

    <!-- Medical Services for AFB, FC, and new individuals for RMB/C and FinReassessment -->
    @if ((((selectedIndividual.age < 19) || isY('data.pregnancyOne.isPregnant'))
    && (isAFBorFC || isApplyMedServicesAndMovedIn)) && (
    ((ageGreaterThanEighteenOnTwentyThree === false) &&
    isN('data.formerFosterCare')) || ageGreaterThanEighteenOnTwentyThree ||
    !isEnabled('data.formerFosterCare'))) {
    <div>
      <div>
        <h2 class="section-header">
          {{ "MEDICAL_SERVICES" | globalTranslate }}
        </h2>
        <hr />
        <section [formGroup]="getControl('data.medicalService')">
          <!-- not full coverage -->
          @if (!isFC) {
          <div>
            @if (isEnabled('data.medicalService.receivedMedSer')) {
            <nh-field
              id="ad_receivedMedSer"
              [mandatory]="false"
              [attr.aria-required]="false"
              label="{{ 'MED_SER_RECEIVED' | globalTranslate }}"
              class="label-section"
            >
              <select
                nhTranslate
                name="receivedMedSer"
                formControlName="receivedMedSer"
                [items]="
                  tableCodeValue('YESNO', 'data.medicalService.receivedMedSer')
                "
                (change)="addDateReceivedMedSer($event)"
                [attr.aria-label]="'MED_SER_RECEIVED' | globalTranslate"
              ></select>
            </nh-field>
            } @if (isY('data.medicalService.receivedMedSer')) {
            <nh-field
              id="ad_dateReceivedMedSer"
              [mandatory]="true"
              [attr.aria-required]="true"
              label="{{ 'MED_SER_DATE_RECEIVED' | globalTranslate }}"
              class="label-section"
            >
              @if (isY('data.medicalService.receivedMedSer')) {
              <div class="hint">
                {{ "MED_SER_DATE_RECEIVED_HINT" | globalTranslate }}
              </div>
              }
              <nh-datepicker>
                <input
                  type="text"
                  name="dateReceivedMedSer"
                  class="form-control"
                  (change)="isInvalidDate($event)"
                  formControlName="dateReceivedMedSer"
                  [maxDate]="today"
                  bsDatepicker
                  nh
                  maxlength="10"
                  [attr.aria-label]="'MED_SER_DATE_RECEIVED' | globalTranslate"
                  [attr.aria-required]="true"
                />
              </nh-datepicker>
            </nh-field>
            }
          </div>
          }
          <!-- full coverage -->
          @if (isFC) {
          <div>
            @if (isEnabled('data.medicalService.receivedMedSer')) {
            <nh-field
              id="ad_receivedMedSer"
              [mandatory]="false"
              [attr.aria-required]="false"
              label="{{ 'HAS_FC' | globalTranslate }} {{
                selectedIndividual | fullname
              }} {{ 'MED_SER_RECEIVED_FC' | globalTranslate }}"
              class="label-section"
            >
              <select
                nhTranslate
                name="receivedMedSer"
                formControlName="receivedMedSer"
                [items]="
                  tableCodeValue('YESNO', 'data.medicalService.receivedMedSer')
                "
                (change)="addDateReceivedMedSer($event)"
                [attr.aria-label]="
                  ('HAS_FC' | globalTranslate) +
                  ' ' +
                  (selectedIndividual | fullname) +
                  ' ' +
                  ('MED_SER_RECEIVED_FC' | globalTranslate)
                "
              ></select>
            </nh-field>
            } @if (isY('data.medicalService.receivedMedSer')) {
            <nh-field
              id="ad_dateReceivedMedSer"
              [mandatory]="true"
              [attr.aria-required]="true"
              label="{{ 'MED_SER_DATE_RECEIVED' | globalTranslate }}"
              class="label-section"
            >
              @if (isY('data.medicalService.receivedMedSer')) {
              <div class="hint">
                {{ "MED_SER_DATE_RECEIVED_HINT" | globalTranslate }}
              </div>
              }
              <nh-datepicker>
                <input
                  type="text"
                  name="dateReceivedMedSer"
                  class="form-control"
                  (change)="isInvalidDate($event)"
                  formControlName="dateReceivedMedSer"
                  [maxDate]="today"
                  bsDatepicker
                  nh
                  maxlength="10"
                  [attr.aria-label]="'MED_SER_DATE_RECEIVED' | globalTranslate"
                  [attr.aria-required]="true"
                />
              </nh-datepicker>
            </nh-field>
            }
          </div>
          }
        </section>
      </div>
    </div>
    } @if (usCitizen && !isRmbRmc &&
    isEnabled('data.helpWithEmergencyServiceBills') && (
    ((ageGreaterThanEighteenOnTwentyThree === false) &&
    isN('data.formerFosterCare')) || ageGreaterThanEighteenOnTwentyThree ||
    !isEnabled('data.formerFosterCare'))) {
    <div>
      <h2 class="section-header">
        {{ "EMERGENCY_MEDICAL" | globalTranslate }}
      </h2>
      <hr />
      <section>
        @if (isEnabled('data.helpWithEmergencyServiceBills')) {
        <nh-field
          id="ad_helpWithEmergencyServiceBills"
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'HAS_1' | globalTranslate }}{{
            selectedIndividual | fullname
          }} {{ 'EMERGENCY_STATIC_TEXT' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="helpWithEmergencyServiceBills"
            [attr.aria-label]="
              ('HAS_1' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('EMERGENCY_STATIC_TEXT' | globalTranslate)
            "
            [attr.aria-required]="true"
            formControlName="helpWithEmergencyServiceBills"
            [items]="
              tableCodeValue('YESNO', 'data.helpWithEmergencyServiceBills')
            "
          ></select>
        </nh-field>
        }
      </section>
    </div>
    }
  </div>
</nh-form>